import React from 'react';
import { Link } from 'react-router-dom';
import { formatBlogDate } from '../data/blogPosts';
import './BlogCard.css';

const BlogCard = ({ post, countryCode }) => {
  return (
    <article className="blog-card">
      <Link 
        to={`/country/${countryCode}/blog/${post.slug}`}
        className="blog-card-link"
        aria-label={`Read article: ${post.title}`}
      >
        <div className="blog-card-image">
          <img 
            src={post.image} 
            alt={post.title}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              // Fallback to a placeholder if image doesn't exist
              e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0xNzUgMTMwSDIyNVYxNzBIMTc1VjEzMFoiIGZpbGw9IiM5Q0EzQUYiLz4KPHBhdGggZD0iTTE1MCAxNDBIMjUwVjE2MEgxNTBWMTQwWiIgZmlsbD0iIzlDQTNBRiIvPgo8L3N2Zz4K';
              e.target.alt = 'Article placeholder';
            }}
          />
          <div className="blog-card-category">{post.category}</div>
        </div>
        <div className="blog-card-content">
          <div className="blog-card-meta">
            <span className="blog-card-date">{formatBlogDate(post.date)}</span>
            <span className="blog-card-separator">•</span>
            <span className="blog-card-read-time">{post.readTime}</span>
          </div>
          <h3 className="blog-card-title">{post.title}</h3>
          <p className="blog-card-excerpt">{post.excerpt}</p>
          <span className="blog-card-read-more">
            Read more →
          </span>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;
